<template>
    <div>
        <h3 class="title is-3">Generate challenges from a map</h3>
        <div>
            <div v-if="!isLoading">
                <div class="field is-horizontal">
                    <div class="field-body">
                        <div class="field">
                            <p>The map <strong>{{mapName}}</strong> contains <strong>{{mapNbChallenges}}</strong>
                                geolocation points.<br/>
                                Do you want to create generic questions with these locations?</p>
                        </div>
                    </div>
                </div>
                <div class="map-previewer">
                    <map-previewer :markers="markers" :center="center" ref="map_previewer" :mapType='mapType'
                                   :height="600" v-if="!isLoading">
                    </map-previewer>
                </div>
            </div>
            <div class="control submit">
                <button class="button is-light btn-margin" @click.prevent="cancel()">Cancel</button>
                <button @click.prevent="generateChallengesFromLocations()" class="button is-primary btn-margin">
                    Generate the {{mapNbChallenges}} challenges
                </button>
            </div>
            <div>{{this.textForChallengesAdded}}</div>
        </div>
    </div>
</template>

<script>
  import mapService from '../services/mapService'
  import displayHelper from '../helpers/display-helper'
  import MapPreviewer from './single/MapPreviewer'
  import questionsService from '../services/questionsService'

  export default {
    name: 'GenerateChallenges',
    data() {
      return {
        isLoading: false,
        mapId: this.$route.params.mapId,
        mapNbChallenges: 0,
        mapName: '',
        map: {},
        markers: [],
        mapType: 'terrain',
        center: {lat: -27.9000739, lng: 153.3159459},
        textForChallengesAdded: ''
      }
    },
    created() {
      this.isLoading = true
      this.loadMapInfo()
      this.textForChallengesAdded = ''
    },
    components: {
      MapPreviewer
    },
    methods: {
      cancel() {
        this.$router.go(-1)
      },
      loadMapInfo() {
        var parent = this
        mapService.getMapInfos(this.mapId)
          .then((map) => {
            this.map = map
            this.mapName = map.name
            this.mapNbChallenges = map.geolocationPoints ? map.geolocationPoints.length : 0
            this.markers = map.geolocationPoints

            console.log(this.markers)
            this.isLoading = false
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops.. An error occurred: ' + err.message)
          })
      },
      async generateChallengesFromLocations() {
        let parent = this

        if (this.map.geolocationPoints) {
          for (const geopoint of this.map.geolocationPoints) {
            var challengeToCreate = {
              name: 'TO BE FILLED - ' + geopoint.title,
              question: 'TO BE FILLED - AUTOMATICALLY IMPORTED FROM ' + this.mapName + ' - ' + this.map.description,
              category: this.mapName,
              type: 'free-text',
              answers: {},
              unlocked_forced: false,
              points: 100,
              activityType: 'Challenge',
              difficulty: 1,
              location: {lat: geopoint.position.lat, lng: geopoint.position.lng},
              allowedAttempts: 1,
              correctAnswer: 'TO BE FILLED'
            }

            console.dir(challengeToCreate)

            await questionsService.addNewQuestion(challengeToCreate, null)
            .then(() => {
              console.log('Challenge for ' + geopoint.title + ' added successfully')
            }).catch((error) => {
              displayHelper.displayError(parent, 'There was an error while importing challenges: ' + error.message)
              return
            })
          }
          displayHelper.displaySuccess(this, `Successfully imported ${this.map.geolocationPoints ? this.map.geolocationPoints.length : 0} questions for ${this.mapName}`)
          this.$router.push({ name: 'Questions', params: { txtFilter: this.mapName } })
        }
      }
    }
  }
</script>

<style scoped>
    .btn-margin {
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 20px;
    }

    .map-previewer {
        margin-top: 20px;
    }
</style>
